export enum AuditEventsEnum {
  CoverageCheckerLinkClicked = 'CoverageCheckerLinkClicked',
}
